import React, {useState} from "react"
import {Wallet} from "@irati/types"

import {Body, H2, H3, Label} from "@irati/ui/src/Typography"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import {walletTracking} from "@irati-tracking/wallet"
import {FormattedMessage, FormattedCurrency, useIntl} from "@irati/utils/lang"
import mainTheme from "@irati/ui/src/global/theme"
import Flex from "@irati/ui/src/Flex"
import {useAppRouteContext} from "@irati/utils/history"
import RewardsTriggerModal from "../RewardsModal/RewardsTriggerModal"
import {Trigger, ActiveCard} from "./styled"
import useAuth from "@irati/auth/helpers/auth/useAuth"
import {FamilyFriendsPopup} from "../FamilyFriendsPopup"
import Button from "@irati/ui/src/Button"
import devToggles from "@irati/dev-toggles"
import {useUsersForBusiness} from "@irati/identity/hooks"

export interface Props {
  wallet: Wallet
  active: boolean
}

export default function RewardWallet({wallet, active}: Props) {
  const {formatMessage} = useIntl()
  const auth = useAuth()
  const [showPopup, setShowPopup] = useState(false)
  const {apps} = useAppRouteContext()
  const {amount = 0, currency} = wallet
  const myFFUsers = {
    businessId: auth.business?.uuid,
    invitedBy: auth.user?.uuid,
    totalOnly: true
  }
  const isFFOff = auth.business?.featureFlags.includes("FriendsAndFamilyOff") || !devToggles.showFriendsAndFamily()
  const {data: apolloUsers} = useUsersForBusiness(myFFUsers, {fetchPolicy: "network-only", skip: isFFOff})
  return (
    <ActiveCard active={active} onClick={() => walletTracking.clickRewardPointsCard()}>
      <Trigger>
        <RewardsTriggerModal />
      </Trigger>

      <H3 color={mainTheme.colors.utility.ink} marginBottom={2}>
        <FormattedMessage id="wallet.reward.admin.card.topup.rewardPoints" />
      </H3>

      <Flex direction="column">
        <Label color={mainTheme.colors.utility.contrast}>
          <FormattedMessage id="wallet.walletBalanceCard.available.header" />
        </Label>
        <H2 color={mainTheme.colors.primary2}>{currency && <FormattedCurrency value={amount} currency={currency} />}</H2>
      </Flex>

      <Body color={mainTheme.colors.utility.contrast} marginTop={2} marginBottom={2}>
        <FormattedMessage id="wallet.availableBalance.info.rewardText" />
      </Body>

      <div>
        <ButtonRouterLink
          primary
          stopPropagation
          full
          onClick={() => walletTracking.clickBrowseRewards(formatMessage({id: "wallet.reward.tracking.source.title"}))}
          to="/"
          app={apps.FLEXIREWARDS}>
          <FormattedMessage id="wallet.rewardPoints.availableBalance.info.button" />
        </ButtonRouterLink>
        {!isFFOff && !!apolloUsers?.total && (
          <ButtonRouterLink stopPropagation full to="/flexi-assign/recipients">
            <FormattedMessage id="wallet.reward.budget.rewardWallet.cta.givePoints" />
          </ButtonRouterLink>
        )}
        {!isFFOff && !apolloUsers?.total && (
          <Button full onClick={() => setShowPopup(true)}>
            <FormattedMessage id="wallet.friendsFamilyBanner.action" />
          </Button>
        )}
      </div>
      <FamilyFriendsPopup showPopup={showPopup} onHide={() => setShowPopup(false)} />
    </ActiveCard>
  )
}
